import client from "@/plugins/axios-plugin";
import Vue from "vue";

export default async function(userData){
    const token =  Vue.$cookies.get("token");
    if(!token) return null;
    try {
        const data = await client.post(`/user`, {
            "name": userData.name,
            "email": userData.email,
            "password": userData.password
          }
          ,{
            headers: {
                authorization: token,
            }
        })
        return data.data;
    } catch (error) {
        
    }
    return null;
}